const categoryMap = {
  "sv-se": {
    categoryMap: [
      {
        categoryName: "sleep-devices",
        categoryTrans: "sömnapnéapparater",
      },
      {
        categoryName: "ventilators",
        categoryTrans: "ventilatorer",
      },
      {
        categoryName: "masks",
        categoryTrans: "masker",
      },
      {
        categoryName: "oral-appliance",
        categoryTrans: "antiapnéskena",
      },
      {
        categoryName: "diagnostics",
        categoryTrans: "diagnostisk",
      },
      {
        categoryName: "accessories",
        categoryTrans: "apparattillbehör",
      },
      {
        categoryName: "software-and-data-management",
        categoryTrans: "datahantering",
      },
    ],
  },
  "nb-no": {
    categoryMap: [
      {
        categoryName: "sleep-devices",
        categoryTrans: "søvnapnéapparater",
      },
      {
        categoryName: "ventilators",
        categoryTrans: "ventilasjonsapparater",
      },
      {
        categoryName: "masks",
        categoryTrans: "masker",
      },
      {
        categoryName: "oral-appliance",
        categoryTrans: "dental-søvnbehandling",
      },
      {
        categoryName: "diagnostics",
        categoryTrans: "diagnostikk",
      },
      {
        categoryName: "accessories",
        categoryTrans: "tilbehør",
      },
      {
        categoryName: "digital-health-solutions",
        categoryTrans: "behandlingsapper",
      },
      {
        categoryName: "software-and-data-management",
        categoryTrans: "programvare",
      }
    ],
  },
  "fi-fi": {
    categoryMap: [
      {
        categoryName: "sleep-devices",
        categoryTrans: "uniapnealaitteet",
      },
      {
        categoryName: "ventilators",
        categoryTrans: "ventilaatiolaitteet",
      },
      {
        categoryName: "masks",
        categoryTrans: "maskit",
      },
      {
        categoryName: "oral-appliance",
        categoryTrans: "uniapneakisko",
      },
      {
        categoryName: "diagnostics",
        categoryTrans: "diagnostiikka",
      },
      {
        categoryName: "accessories",
        categoryTrans: "lisävarusteet",
      },
      {
        categoryName: "software-and-data-management",
        categoryTrans: "tiedonhallinta",
      },
    ],
  },
};

export function getCategory(categoryTrans, region) {
  try {
    if (categoryMap[region]) {
      const catMap = categoryMap[region].categoryMap;
      const findCat = catMap.find(
        (item) =>
          item.categoryTrans.toLowerCase() === categoryTrans.toLowerCase()
      );
      return findCat ? findCat.categoryName : categoryTrans.toLowerCase();
    } else {
      return categoryTrans.toLowerCase();
    }
  } catch (error) {
    console.log(error);
  }
}

export function getCategoryTranslation(categoryTrans, region) {
  try {
    if (categoryMap[region]) {
      const catMap = categoryMap[region].categoryMap;
      const findCat = catMap.find(
        (item) =>
          item.categoryName.toLowerCase() === categoryTrans.toLowerCase() ||
          item.categoryTrans.toLowerCase() === categoryTrans.toLowerCase()
      );
      return findCat ? findCat.categoryTrans : categoryTrans.toLowerCase();
    } else {
      return categoryTrans.toLowerCase();
    }
  } catch (error) {
    console.log(error);
  }
}
